import { IGetAllProjetoInformacoesUseCase } from "../../../presentation/useCases/read/get_all_projeto_informacoes_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IProjetosRepository } from "../../repositories/projetos_repository";
import { InformacoesLista } from "../../models/informacoes_lista";
import { InformacoesFilter } from "../../models/informacoes_filter";



export class GetAllProjetoInformacoesUseCase
  extends BasePaginatedUseCase<InformacoesLista>
  implements IGetAllProjetoInformacoesUseCase
{
  constructor(private readonly repository: IProjetosRepository) {
    super();
  }

  async getAllProjetoInformacoes(request: InformacoesFilter, page: number,
    rowsPerPage: number,): Promise<void>{
    const response = await this.repository.getAllProjetoInformacoes(request, page, rowsPerPage);

    this._items = response.items;
    this._totalPages = response.totalPages;
    this._totalItems = response.totalItems;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
  }
}
